module.exports = __webpack_public_path__ + "img/notLicenceImgUrl.029152a8.png";